import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ReplaySubject } from "rxjs";
import { AlertDialogService } from "../../components/_alert-dialog/alert-dialog.service";
import { HttpService } from "../../services/http.service";
import { ToolsService } from "../../services/tools.service";
import { Civilite } from "../../interfaces/Civilite";
import { CiviliteDialogService } from "../../dialogs/civilite-dialog/civilite-dialog.service";

@Component({
  selector: "select-civilite",
  templateUrl: "select-civilite.html",
  standalone: false,
})
export class SelectCivilite implements OnInit {
  @Input() ngModel: number = 0;
  @Input() disabled?: boolean = false;
  @Input() enableCreate?: boolean = false;
  @Input() enableEdit?: boolean = false;

  @Output() ngModelChange = new EventEmitter();
  @Output() selectionChange = new EventEmitter();

  public oLogUser = JSON.parse(sessionStorage.getItem("Equora_User"));
  public elements: Civilite[];
  public filteredElements: ReplaySubject<Civilite[]> = new ReplaySubject<
    Civilite[]
  >(1);
  public bLoad: boolean;

  constructor(
    private _http: HttpService,
    private _tools: ToolsService,
    private _alert: AlertDialogService,
    private _s: CiviliteDialogService
  ) {}

  ngOnInit(): void {
    this.getElements();
  }

  getElements(): void {
    this.bLoad = true;
    this._http.GET(
      "/api/civilite",
      null,
      (result) => {
        if (result.isOk) {
          this.elements = result.obj;
          this.filteredElements.next(this.elements.slice());
          this.change();
        } else {
          this._alert.openDialog(
            "Erreur",
            { message: result.message },
            "error"
          );
        }
        this.bLoad = false;
      },
      (error) => {
        this._tools.showHttpError(error);
        this.bLoad = false;
      }
    );
  }

  search(
    search: string,
    elements: Civilite[],
    filteredElements: ReplaySubject<Civilite[]>
  ) {
    if (!search) {
      filteredElements.next(elements.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    filteredElements.next(
      elements.filter(
        (e) =>
          (e.civilite_Code + " - " + e.civilite_Libelle)
            .toLowerCase()
            .indexOf(search) > -1
      )
    );
  }

  change(): void {
    this.ngModelChange.emit(this.ngModel);
    const selected = this.elements.find((e) => e.civilite_ID == this.ngModel);
    this.selectionChange.emit(selected ?? null);
  }

  open(id: number) {
    this._s.openDialog(id, () => {
      this.getElements();
    });
  }
}
